import React from 'react';
import Admin from "../../../components/pages/grid/Admin/Admin";

const AdminGridPage = () => {
    return <Admin />
};

export default AdminGridPage;